import {
    LIST_ROOMS,
    LIST_ROOMS_SUCCESS,
    LIST_ROOMS_ERROR,
    ADD_ROOMS,
    SAVE_ROOMS,
    SAVE_ROOMS_SUCCESS,
    SAVE_ROOMS_ERROR,
    EDIT_ROOMS,
    UPDATE_ROOMS,
    UPDATE_ROOMS_SUCCESS,
    UPDATE_ROOMS_ERROR,
    DELETE_ROOMS,
    DELETE_ROOMS_SUCCESS,
    DELETE_ROOMS_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    rooms: null,
    error: null,
    loading: false,
    roomSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_ROOMS:
            return {
                ...state,
                loading: true
            }
        case LIST_ROOMS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_ROOMS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                rooms: action.payload
            }
        case SAVE_ROOMS:
        case DELETE_ROOMS:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_ROOMS:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_ROOMS_ERROR:
        case UPDATE_ROOMS_ERROR:
        case DELETE_ROOMS_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_ROOMS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                rooms: [...state.rooms, action.payload]
            }
        case ADD_ROOMS:
            return {
                ...state,
                roomSelected: null,
                isEdit: false
            }
        case EDIT_ROOMS:
            return {
                ...state,
                roomSelected: action.payload,
                isEdit: true
            }
        case UPDATE_ROOMS_SUCCESS:
        case DELETE_ROOMS_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                rooms: state.rooms.map(room => 
                    room.id === action.payload.id ? room = action.payload : room
                ),
                roomSelected: null
            }
        // case DELETE_ROOMS_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         rooms: state.rooms.filter( room => room.id !== action.payload)
        //     }
        default:
            return state;
    }
}